var RippleFoundation = /** @class */ (function () {
    function RippleFoundation(_adapter) {
        this._adapter = _adapter;
        this._unbounded = false;
    }
    RippleFoundation.prototype.initialize = function () {
        this._adapter.initialize(this._target, this._unbounded);
    };
    RippleFoundation.prototype.disconnect = function () {
        this._adapter.destroy();
    };
    RippleFoundation.prototype.layout = function () {
        this._applyTarget();
    };
    RippleFoundation.prototype._applyTarget = function () {
        this._adapter.destroy();
        this._adapter.initialize(this._target, this._unbounded);
    };
    Object.defineProperty(RippleFoundation.prototype, "target", {
        get: function () {
            return this._target;
        },
        set: function (value) {
            if (this._target !== value) {
                this._target = value;
                this._applyTarget();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RippleFoundation.prototype, "unbounded", {
        get: function () {
            return this._unbounded;
        },
        set: function (value) {
            if (this._unbounded !== value) {
                this._unbounded = value;
                this._applyTarget();
            }
        },
        enumerable: true,
        configurable: true
    });
    return RippleFoundation;
}());
export { RippleFoundation };
